import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { equipmentSettingsLogListKey } from '@pages/MultiplicationFactors/services/useEquipmentSettingsLogListInfiniteQuery';

import { apiClient } from '@services/apiClient';
import { templatesListKey } from '@services/useTemplatesListQuery';

import { allEquipmentsListKey } from './useAllEquipmentsListQuery';

const deleteEquipmentTemplateFn = (data: {
  recalculate_cost_saving: number;
  id: number;
  equipment: number[];
}) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/template/equipment`, {
    data,
  });

export const useDeleteEquipmentTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteEquipmentTemplateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [templatesListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [allEquipmentsListKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentSettingsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
